import { isAndroidDevice } from '../utils/isAndroidDevice';
import { isAppleDevice } from '../utils/isAppleDevice';
import { isWeb } from '../utils/isWeb';
import { isWindowsDevice } from '../utils/isWindowsDevice';
import { AndroidStorage } from './AndroidStorage';
import { AppleStorage } from './AppleStorage';
import { WebStorage } from './WebStorage';
import { WindowsStorage } from './WindowsStorage';

function getStorage() {
  let storage;
  if (isWeb()) {
    storage = new WebStorage();
  } else if (isAndroidDevice()) {
    storage = new AndroidStorage();
  } else if (isAppleDevice()) {
    storage = new AppleStorage();
  } else if (isWindowsDevice()) {
    storage = new WindowsStorage();
  } else {
    throw new Error('Unknown device');
  }
  return storage;
}
export const Storage = getStorage();
